import React from "react";

const OPEN_PRINT_VISITOR_PASS_MODAL = "locale/visitors/visits/OPEN_PRINT_VISITOR_PASS_MODAL";
const CLOSE_PRINT_VISITOR_PASS_MODAL = "locale/visitors/visits/CLOSE_PRINT_VISITOR_PASS_MODAL";

export const openPrintVisitorPassModal = (page, scope, visitorIndexes, visitIndex, hostIndex) => ({
    type: OPEN_PRINT_VISITOR_PASS_MODAL,
    payload: {
        page: page,
        scope: scope,
        visitorIndexes: visitorIndexes,
        visitIndex: visitIndex,
        hostIndex: hostIndex,
    },
})

export const closePrintVisitorPassModal = () => ({
    type: CLOSE_PRINT_VISITOR_PASS_MODAL
})

export const initialState = {
    page: false,
    scope: false,
    visitorIndexes: false,
    visitIndex: false,
    hostIndex: false,
}

export const PassPrintReducer = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_PRINT_VISITOR_PASS_MODAL: {
            return {
                ...state,
                page: action.payload.page,
                scope: action.payload.scope,
                visitorIndexes: action.payload.visitorIndexes,
                visitIndex: action.payload.visitIndex,
                hostIndex: action.payload.hostIndex,
            }
        }

        case CLOSE_PRINT_VISITOR_PASS_MODAL: {
            return {
                ...state,
                page: false,
                scope: false,
                visitorIndexes: false,
                visitIndex: false,
                hostIndex: false,
            }
        }

        default:
            return state;
    }
}
